import { render, staticRenderFns } from "./AllProjects.vue?vue&type=template&id=6dc791cb&scoped=true&"
import script from "./AllProjects.vue?vue&type=script&lang=js&"
export * from "./AllProjects.vue?vue&type=script&lang=js&"
import style0 from "./AllProjects.vue?vue&type=style&index=0&id=6dc791cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc791cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dc791cb')) {
      api.createRecord('6dc791cb', component.options)
    } else {
      api.reload('6dc791cb', component.options)
    }
    module.hot.accept("./AllProjects.vue?vue&type=template&id=6dc791cb&scoped=true&", function () {
      api.rerender('6dc791cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/Projects/AllProjects.vue"
export default component.exports